import { render, staticRenderFns } from "./TabsSlots.vue?vue&type=template&id=2aeb7c3e&scoped=true&"
import script from "./TabsSlots.vue?vue&type=script&lang=ts&"
export * from "./TabsSlots.vue?vue&type=script&lang=ts&"
import style0 from "./TabsSlots.vue?vue&type=style&index=0&id=2aeb7c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb7c3e",
  null
  
)

export default component.exports